var _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyWeExist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4404",
    height: 512,
    viewBox: "0 0 16.933333 16.933334",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4384",
    gradientUnits: "userSpaceOnUse",
    x1: 4.875,
    x2: 12.295,
    y1: 288.581735,
    y2: 288.581735
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4168",
    offset: 0,
    stopColor: "#feaa2b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4176",
    offset: 0.50033963,
    stopColor: "#ffee58"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4170",
    offset: 1,
    stopColor: "#feaa2b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -280.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2177",
    d: "m12.288657 290.79106a.26460979.26460979 0 0 0 -.167432.0656c-.77479.68024-1.723263 1.13151-2.7398846 1.30328a.26460979.26460979 0 0 0 -.199988.36328l1.5962856 3.80546a.26460979.26460979 0 0 0 .489376-.004l.732255-1.8247 1.851566.74311a.26460979.26460979 0 0 0 .342615-.34779l-1.653646-3.94241a.26460979.26460979 0 0 0 -.251147-.16226z",
    fill: "#ff5757",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2181",
    d: "m4.3924978 290.95591-1.6526122 3.93981c-.090699.21659.1246855.43523.3426148.34778l1.8515666-.74311.7322551 1.8247c.088333.21919.3978272.22146.4893757.004l1.5983521-3.81009c.065977-.15742-.032143-.3352-.2005047-.36328-1.0169398-.16927-1.9665712-.61833-2.7429849-1.29656-.047052-.041-.1070885-.0641-.1694987-.0651-.1082479-.002-.2067054.0624-.2485638.16226z",
    fill: "#ff5757",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2173",
    d: "m8.466798 280.59595c-3.3577493 0-6.0859375 2.72818-6.0859375 6.08593s2.7281882 6.08399 6.0859375 6.08399c3.357749 0 6.085937-2.72624 6.085937-6.08399s-2.728188-6.08593-6.085937-6.08593z",
    fill: "#ffcb3c",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2336",
    d: "m8.466798 281.91821c-2.627122 0-4.7617187 2.13655-4.7617187 4.76367 0 2.62713 2.1345967 4.76172 4.7617187 4.76172s4.761719-2.13459 4.761719-4.76172c0-2.62712-2.134597-4.76367-4.761719-4.76367z",
    fill: "#ffea54",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2974",
    d: "m8.4648449 283.64282a.26460982.26460982 0 0 0 -.2285156.17188l-.7011721 1.85742-1.9863281.0605a.26460982.26460982 0 0 0 -.15625.4707l1.5488283 1.24219-.5546876 1.90625a.26460982.26460982 0 0 0 .4003908.29492l1.658203-1.08985 1.6425784 1.11719a.26460982.26460982 0 0 0 .404297-.28906l-.5234376-1.91602 1.5683586-1.21484a.26460982.26460982 0 0 0 -.148437-.47461l-1.9843746-.0938-.6718754-1.86719a.26460982.26460982 0 0 0 -.2675781-.17578z",
    fill: "#feaa2b",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyWeExist);
export default __webpack_public_path__ + "static/media/why-we-exist.0821b9947514643a25f41b465112e1dd.svg";
export { ForwardRef as ReactComponent };